module.exports = __webpack_public_path__ + "img/16-onebg.ecdaea62.jpg";